import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { tabulation, gmToolNewPage, gmTool } from "@/mixins/index";
import { createRoleList } from "@/api/dataAll/dataAll";
import { serverList } from "@/api/gmtool/packageCode";
import { serverList as hdServerList } from "@/api/gmtool/packageCode";
import { serverList as yjServerList } from "@/api/gmToolNew/gmToolNew";
export default {
  name: "serverRoleList",
  mixins: [tabulation, gmToolNewPage, gmTool],
  data: function data() {
    return {
      tableData: [],
      searchData: {
        page: 1,
        page_size: 10
      },
      exportdataloading: false
    };
  },
  computed: _objectSpread({}, mapState("d2admin", {
    severlist: function severlist(state) {
      return state.user.GMauthority;
    }
  })),
  created: function created() {
    this.searchData.env_id = this.szgmEnv.length ? this.szgmEnv[0].id : '';

    if (this.rawData.game_mark.indexOf('yjfm') == -1) {
      this.getServer();
    }
  },
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      this.searchData.page = e;
      this.reqLoading = true;

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      createRoleList(_objectSpread(_objectSpread({}, this.searchData), {}, {
        server_id: this.paramsData.server_id
      })).then(function (res) {
        if (res.code == 200) {
          _this.tableData = res.data.data || [];
          _this.total = res.data.total;
          var list = _this.rawData.game_mark.indexOf('royalpirates') > -1 ? _this.serverList : _this.serverListYJ;

          _this.tableData.forEach(function (item) {
            var foundData = list.find(function (b) {
              return b.serverID == item.server_id;
            });
            item.server_name = foundData ? foundData.serverName : '/';
          });
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    sizeChange: function sizeChange(e) {
      this.searchData.page_size = e;
      this.searchClick(1);
    },
    exportdata: function exportdata() {
      var _this2 = this;

      this.exportdataloading = true;
      createRoleList(_objectSpread(_objectSpread({}, this.searchData), {}, {
        server_id: this.paramsData.server_id,
        page_size: ''
      })).then(function (res) {
        if (res.code == 200) {
          var data = res.data.data;
          var list = _this2.rawData.game_mark.indexOf('royalpirates') > -1 ? _this2.serverList : _this2.serverListYJ;
          data.forEach(function (item) {
            item.isRoll = item.is_roll == 1 ? _this2.$t('rollServer') : _this2.$t('nonRollServer');
            var foundData = list.find(function (b) {
              return b.serverID == item.server_id;
            });
            item.server_name = foundData ? foundData.serverName : '/';
          });
          var columns = [{
            label: _this2.$t('game'),
            prop: "game"
          }, {
            label: _this2.$t('platform'),
            prop: "platform"
          }, {
            label: _this2.$t('channel'),
            prop: "channel"
          }, {
            label: _this2.$t('pkg'),
            prop: "pkg"
          }, {
            label: _this2.$t('adChannel'),
            prop: "ad_channel"
          }, {
            label: _this2.$t('adPlacement'),
            prop: "ad_placement"
          }, {
            label: _this2.$t('serverId'),
            prop: "server_id"
          }, {
            label: _this2.$t('serverName'),
            prop: "server_name"
          }, {
            label: _this2.$t('roleId'),
            prop: "role_id"
          }, {
            label: _this2.$t('roleName'),
            prop: "role_name"
          }, {
            label: "user_id",
            prop: "user_id"
          }, {
            label: _this2.$t('isRolling'),
            prop: "isRoll"
          }, {
            label: _this2.$t('createRoleTime'),
            prop: "time"
          }, {
            label: _this2.$t('firstCreateAccountTime'),
            prop: "register_time"
          }, {
            label: _this2.$t('playerCharacter'),
            prop: "character_id"
          }];

          _this2.$export.excel({
            columns: columns,
            data: data,
            title: _this2.$route.meta.title
          });
        }
      }).finally(function () {
        _this2.exportdataloading = false;
      });
    }
  }
};